//10:00:00转化成秒数
export let toSeconds = (value = '00:00:00') => {
    let arr = value.split(':');
    if (arr.length != 3) {
        return 0;
    }
    let data = parseInt(arr[0]) * 3600 + parseInt(arr[1]) * 60 + parseInt(arr[2]);
    return data;
};
//秒数转化成10:00:00
export let formatSeconds = (value = 0) => {
    let secondTime = parseInt(value); // 秒
    let minuteTime = 0; // 分
    let hourTime = 0; // 小时
    if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
            //获取小时，获取分钟除以60，得到整数小时
            hourTime = parseInt(minuteTime / 60);
            //获取小时后取佘的分，获取分钟除以60取佘的分
            minuteTime = parseInt(minuteTime % 60);
        }
    }
    let strSecondTime = secondTime.toString();
    let strMinuteTime = minuteTime.toString();
    let strHourTime = hourTime.toString();
    if (parseInt(secondTime) < 10) {
        strSecondTime = '0' + secondTime.toString();
    }
    if (parseInt(minuteTime) < 10) {
        strMinuteTime = '0' + minuteTime.toString();
    }
    if (parseInt(hourTime) < 10) {
        strHourTime = '0' + hourTime.toString();
    }
    let result = strHourTime + ':' + strMinuteTime + ':' + strSecondTime;
    return result;
};
//格式化时间范围为  10h51m  不加秒s 如果小于60秒就写秒 40s
export let formatTimeRange = (time = 0) => {
    let rangeArr = formatSeconds(time).split(':');
    if (time >= 60 || time == 0) {
        return `${Number(rangeArr[0])}h${Number(rangeArr[1])}m`;
    } else {
        return `${Number(rangeArr[0])}h${Number(rangeArr[1])}m${Number(rangeArr[2])}s`;
    }
};
//获得试用率 run stby alarm stop off
export let getOee = (item = { run: 0, stby: 0, alarm: 0, stop: 0, off: 0 }) => {
    let total = item.run + item.stby + item.alarm + item.stop + item.off;
    if (total > 0) {
        return (item.run / total) * 100;
    }
    return 0;
};



// WEBPACK FOOTER //
// ./src/libs/util.js